import {Pagination} from '../pagination.model';
import {Prestation} from '../../../../prestations/shared/model/prestation.model';

export class PrestationPage extends Pagination {
  content: Prestation[] = [];
}
